import { QueryObserverResult, useQuery } from '@tanstack/react-query';
import { APIClient } from 'api/APIClient';
import { UserInfoResults } from 'api/types/types';
import { QueryKeys } from 'constants/queryKeys';

export async function getUser(): Promise<UserInfoResults> {
  const { data } = await APIClient().get('/user');
  return data;
}

export function useUserQuery(): QueryObserverResult<UserInfoResults, unknown> {
  return useQuery({
    queryKey: [QueryKeys.USER_INFO_QUERY],
    queryFn: () => getUser(),
    enabled: true,
    staleTime: Infinity,
    retry: false,
  });
}
